/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import textStyles from '../../foundations/textStyles'

export default {
    baseStyle: {
        separator: {
            display: 'flex',
            boxSize: 4
        },
        item: {
            maxWidth: [72, 'none', 'none', 'none'],
            whiteSpace: 'nowrap',
            my: 2
        },
        link: {
            ...textStyles['Light Medium'],
            transitionProperty: 'all',
            transitionDuration: '0.5s',
            transitionTimingFunction: 'ease',
            textDecoration: 'underline',
            color: 'stokkeCore.black',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            _hover: {
                textDecoration: 'none'
            },
            _focusVisible: {
                boxShadow: 'none'
            }
        },
        product: {
            ...textStyles['Light Medium'],
            textDecoration: 'none',
            cursor: 'default'
        }
    },
    parts: ['container', 'separator', 'link', 'product']
}
